(function () {
  'use strict';

  // Skip entirely on touch devices
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

  var MAX_ROTATION = 8; // degrees

  function initTiltCards() {
    var cards = document.querySelectorAll('[data-tilt]');

    cards.forEach(function (card) {
      if (card.dataset.tiltInit) return;
      card.dataset.tiltInit = 'true';

      // Set perspective on parent so 3D transforms are visible
      if (card.parentElement) {
        card.parentElement.style.perspective = '1000px';
      }

      // Ensure glare overlay stays clipped to card shape
      if (!card.style.position) card.style.position = 'relative';
      card.style.overflow = card.style.overflow || 'hidden';

      // Create glare overlay
      var glare = document.createElement('div');
      glare.className = 'tilt-glare';
      card.appendChild(glare);

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateX = ((y - centerY) / centerY) * -MAX_ROTATION;
        var rotateY = ((x - centerX) / centerX) * MAX_ROTATION;

        // Fast transition during tracking so it feels responsive
        card.style.transition = 'transform 0.1s ease, box-shadow 0.1s ease';
        card.style.transform =
          'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale3d(1.03, 1.03, 1.03)';

        // Dynamic grey edge glow — shadow casts opposite to cursor (light-reflection feel)
        var shadowX = ((centerX - x) / centerX) * 12;
        var shadowY = ((centerY - y) / centerY) * 12;
        var intensity = Math.min(Math.sqrt(Math.pow((x - centerX) / centerX, 2) + Math.pow((y - centerY) / centerY, 2)), 1);
        card.style.boxShadow =
          shadowX + 'px ' + shadowY + 'px 15px rgba(80,80,80,' + (intensity * 0.35).toFixed(2) + '),' +
          (shadowX * 1.5) + 'px ' + (shadowY * 1.5) + 'px 30px rgba(80,80,80,' + (intensity * 0.2).toFixed(2) + '),' +
          '0px 0px 5px rgba(80,80,80,' + (intensity * 0.15).toFixed(2) + ')';

        // Update glare position
        card.style.setProperty('--glare-x', ((x / rect.width) * 100) + '%');
        card.style.setProperty('--glare-y', ((y / rect.height) * 100) + '%');
      });

      card.addEventListener('mouseleave', function () {
        // Spring back with longer ease
        card.style.transition = 'transform 0.4s cubic-bezier(0.03, 0.98, 0.52, 0.99), box-shadow 0.4s ease';
        card.style.transform = 'rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
        card.style.boxShadow = '0 0 0 rgba(80,80,80,0)';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTiltCards);
  } else {
    initTiltCards();
  }

  // Re-run when sections reload in theme editor
  document.addEventListener('shopify:section:load', initTiltCards);

  // Re-run for dynamically injected cards (AJAX, infinite scroll)
  var observer = new MutationObserver(function (mutations) {
    var hasNew = mutations.some(function (m) { return m.addedNodes.length > 0; });
    if (hasNew) setTimeout(initTiltCards, 100);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
